let CatID = '';
export const setCategoryData = (data) => {
  console.log(data)
  CatID = data;
}
export const getCategoryData = () => {
  return CatID;
}

let subCatID = '';
export const setSubCategoryData = (data) => {
  subCatID = data;
}
export const getSubCategoryData = () => {
  return subCatID;
}

export const selectMonths=['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']


